import { render, staticRenderFns } from "./overdueDetailList.vue?vue&type=template&id=53133734&scoped=true"
import script from "./overdueDetailList.vue?vue&type=script&lang=js"
export * from "./overdueDetailList.vue?vue&type=script&lang=js"
import style0 from "./overdueDetailList.vue?vue&type=style&index=0&id=53133734&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53133734",
  null
  
)

export default component.exports